module.exports = __webpack_public_path__ + "static/circle-blue-6b89ea52e1aecf85e7658f2d25c16f4a.png";